import React from 'react';
import '../App.scss';

const Footer = ()=>{
  return(
    <center >
      <p class="credit-to credit">developed by </p>
      <a href="https://www.github.com/avinashbharti97"><p class="credit">avinashbharti97</p></a>
    </center>
  )
}     
export default Footer 
